import { ProductCardProps } from "./ProductCard";

export interface MockProductItem extends ProductCardProps {
  category: string;
}

export const mockProducts: MockProductItem[] = [
  // 1. Motor insurance
  {
    badge: "🚗 Popular",
    title: "Smart Drive Comprehensive",
    subtitle_insurancetype: "Comprehensive motor insurance",
    subtitle_description: "Coverage by AXA Motor",
    age_range: "For ages 18 - 75 years",
    insurance_logo: "/static/AXA.svg",
    benefit_items: [
      "Full crash & theft protection",
      "Third-party property liability up to 5M Baht",
      "24/7 roadside assistance",
    ],
    prices: 18500,
    category: "motor",
  },
  {
    badge: "💡 Best Value",
    title: "Smart Drive Third-Party Plus",
    subtitle_insurancetype: "Third-party motor insurance",
    subtitle_description: "Coverage by AXA Motor",
    age_range: "For ages 18 - 75 years",
    insurance_logo: "/static/AXA.svg",
    benefit_items: [
      "Third-party life & property protection",
      "Fire & theft coverage included",
    ],
    prices: 7500,
    category: "motor",
  },
  // 2. Electric vehicle insurance
  {
    badge: "⚡ EV Exclusive",
    title: "EV Protector Pro",
    subtitle_insurancetype: "EV Comprehensive insurance",
    subtitle_description: "Guaranteed by AIA Insurance",
    age_range: "For ages 21 - 65 years",
    insurance_logo: "/static/AIA.svg",
    benefit_items: [
      "EV home charger damage coverage",
      "Battery replacement coverage up to 100%",
      "Premium roadside towing",
    ],
    prices: 22000,
    category: "ev",
  },
  // 3. Health insurance
  {
    badge: "👍 30% off this month",
    title: "Smart Care Essential",
    subtitle_insurancetype: "Comprehensive health insurance",
    subtitle_description: "Guaranteed by AXA Insurance",
    age_range: "For ages 20 - 59 years",
    insurance_logo: "/static/AXA.svg",
    benefit_items: [
      "Maximum room charge in the market for the same premium group",
      "Cancer treatment coverage",
      "No health check required",
      "No advance payment needed at network hospitals",
    ],
    prices: 14999,
    category: "health",
  },
  {
    badge: "🔥 Best seller",
    title: "Lump-sum Health Premium",
    subtitle_insurancetype: "Lump-sum health insurance",
    subtitle_description: "Coverage by AIA Life Insurance",
    age_range: "For ages 20 - 59 years",
    insurance_logo: "/static/AIA.svg",
    benefit_items: [
      "High limit lump-sum medical payout",
      "ICU charges covered up to 100%",
      "OPD clinic benefits included",
    ],
    prices: 19800,
    category: "health",
  },
  // 4. Child health insurance
  {
    badge: "👶 Kids First",
    title: "Junior Health Protector",
    subtitle_insurancetype: "Comprehensive child health",
    subtitle_description: "Coverage by AIA Life Insurance",
    age_range: "For ages 0 - 15 years",
    insurance_logo: "/static/AIA.svg",
    benefit_items: [
      "Common childhood illness coverage",
      "Vaccination & check-up support",
      "24/7 pediatric consultation hotline",
    ],
    prices: 12500,
    category: "child-health",
  },
  // 5. Personal accident insurance
  {
    badge: "🛡️ 24/7 Cover",
    title: "Accident Care Active",
    subtitle_insurancetype: "PA Standard insurance",
    subtitle_description: "Coverage by AXA Insurance",
    age_range: "For ages 1 - 70 years",
    insurance_logo: "/static/AXA.svg",
    benefit_items: [
      "Accidental medical expenses coverage",
      "Double benefit for public transport accidents",
      "Inpatient cash allowance per day",
    ],
    prices: 2500,
    category: "personal-accident",
  },
  // 6. Cancer insurance
  {
    badge: "🎗️ Cancer Cover",
    title: "Cancer Care Plus",
    subtitle_insurancetype: "Cancer Lump-sum insurance",
    subtitle_description: "Guaranteed by AIA Life",
    age_range: "For ages 16 - 60 years",
    insurance_logo: "/static/AIA.svg",
    benefit_items: [
      "Instant payout upon diagnosis of any stage cancer",
      "Chemotherapy & targeted therapy costs coverage",
      "Premium waiver during treatment",
    ],
    prices: 5400,
    category: "cancer",
  },
  // 7. Life insurance
  {
    badge: "🔒 Family Legacy",
    title: "Whole Life Secure",
    subtitle_insurancetype: "Term Life insurance",
    subtitle_description: "Guaranteed by AIA Life",
    age_range: "For ages 20 - 65 years",
    insurance_logo: "/static/AIA.svg",
    benefit_items: [
      "Guaranteed death benefit for family support",
      "Flexible premium term options",
      "Tax deduction up to 100,000 Baht",
    ],
    prices: 8900,
    category: "life",
  },
  // 8. Travel insurance
  {
    badge: "✈️ Easy Go",
    title: "Global Travel Safe (Single Trip)",
    subtitle_insurancetype: "Single-trip travel insurance",
    subtitle_description: "Coverage by AXA Travel",
    age_range: "For ages 1 - 85 years",
    insurance_logo: "/static/AXA.svg",
    benefit_items: [
      "Flight delay & baggage loss compensation",
      "Worldwide emergency medical evacuation",
      "COVID-19 medical cover abroad",
    ],
    prices: 650,
    category: "travel",
  },
  {
    badge: "🌍 Frequent Flyer",
    title: "Annual Wanderer",
    subtitle_insurancetype: "Annual travel insurance",
    subtitle_description: "Coverage by AXA Travel",
    age_range: "For ages 1 - 85 years",
    insurance_logo: "/static/AXA.svg",
    benefit_items: [
      "Unlimited trips per year (up to 90 days/trip)",
      "Accidental death & disability cover",
      "Emergency support hotline 24/7",
    ],
    prices: 3200,
    category: "travel",
  },
];
